const common = {
    required: {required: true, message: "该项不能为空", trigger: ['change','blur']},
}

export default common